import DatePicker from "react-datepicker";
import "./style.css";

const AdminInputTimePicker = ({
  prefixIcon = null,
  suffixIcon = null,
  placeholder = "",
  mb = "mb-3",
  onSelectDate,
  label = null,
  value
}) => {
  return (
    <>
      <div className={mb}>
        {label && <label className="tw:!mb-1 tw:!text-[15px] tw:!text-[#8D8D8D]">{label}</label>}
        <div className="w-100 rounded border">
          <div className="tw:flex! tw:justify-center! tw:items-center! d-flex gap-2 input-container">
            {prefixIcon && (
              <span className="ms-3">{prefixIcon}</span>
            )}

            <DatePicker
              showTimeSelect
              showTimeSelectOnly
              timeIntervals={5}
              timeFormat="HH:mm"
              dateFormat="HH:mm"
              className={`
                tw:border-none 
                tw:outline-none 
                tw:w-full 
                tw:!leading-[32px] 
                tw:rounded 
                tw:border-0 
                tw:py-2 
                tw:!text-[15px] 
                tw:!font-['Hanken_Grotesk'] 
                tw:placeholder:!text-[15px] 
                tw:placeholder:!font-['Hanken_Grotesk'] 
                ${prefixIcon != null ? "" : "px-3"}
              `}
              placeholderText={placeholder}
              onChange={(date) => {
                onSelectDate(date);
              }}
              selected={value}
            />
            {suffixIcon && (
              <span className="me-3">{suffixIcon}</span>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminInputTimePicker;
